module.exports = __webpack_public_path__ + "static/media/facility-report.0711a104.svg";